const { trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		const links = this.root.querySelectorAll('.ir-search-results--link');
		const navLinks = this.root.querySelectorAll('.pages-nav--number');
		const navLinkFirst = this.root.querySelector('.pages-nav--first');
		const navLinkLast = this.root.querySelector('.pages-nav--last');

		links.forEach(link => {
			const title = link.querySelector('.ir-search-results--title').innerHTML;
			link.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: 'V3-Investor Search Results',
					widget_title: title,
					link_text: 'No label: clickable title',
					link_url: link.href,
					button_type: '',
				});
			});
		});

		navLinks.forEach(navLink => {
			navLink.addEventListener('click', () => {
				const navLinkText = navLink ? navLink.innerHTML.trim() : 'No text';
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: 'V3-Investor-search-results',
					widget_title: 'No title',
					widget_type: 'search',
					link_text: navLinkText,
					link_url: navLink.href ? navLink.href : 'No url',
					interaction_type: `page ${navLinkText}`,
				});
			});
		});

		navLinkFirst.addEventListener('click', () => {
			this.navigationArrowTrackingGa4(navLinkFirst, 'first');
		});

		navLinkLast.addEventListener('click', () => {
			this.navigationArrowTrackingGa4(navLinkLast, 'last');
		});
	},
	navigationArrowTrackingGa4(mainItem, interactionType) {
		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: 'V3-Investor-search-results',
			widget_title: 'No title',
			widget_type: 'search',
			link_text: mainItem ? mainItem.innerHTML.trim() : 'No text',
			link_url: mainItem.href ? mainItem.href : 'No url',
			interaction_type: interactionType,
		});
	},
};
